<template>
  <b-dropdown dropup :text="$t(text)" :variant="variant" :size="size" class="pagination-select">
    <b-dropdown-item
      v-for="(item, index) in options"
      :key="index"
      @click="selected(index)"
      :active="item.value == value"
    >{{$t(item.text)}}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "bulkActionSelect",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {},
    variant: {
      type: String,
      default: () => ""
    },
    size: {
      type: String,
      default: () => ""
    }
  },
  mounted() {
    this.$emit("input", null);
  },
  data() {
    return {
      text: "Select Operation"
    };
  },
  methods: {
    selected(index) {
      this.text = this.options[index].text;
      this.$emit("input", this.options[index]);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
